import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { createFilterSlice, initialFilterState } from './slices/filterSlice';
import { createSearchSlice, initialSearchState } from './slices/searchSlice';
import { createRecentSearchesSlice, initialRecentSearchesState } from './slices/recentSearchesSlice';
import { createTyreSlice, initialTyreState } from './slices/tyreSlice';
import { createQuantitySlice, initialQuantityState } from './slices/quantitySlice';
import { createApiSlice } from './slices/apiSlice';

const useSearchStore = create(
  persist(
    (set, get) => ({
      // Combine all slices
      ...createFilterSlice(set, get),
      ...createSearchSlice(set, get),
      ...createRecentSearchesSlice(set, get),
      ...createTyreSlice(set, get),
      ...createQuantitySlice(set, get),
      ...createApiSlice(set, get),
    }),
    {
      name: '@porsche/search-preferences',
      partialize: (state) => ({
        recentSearches: state.recentSearches,
        recentSearchesEnabled: state.recentSearchesEnabled,
        suggestionsEnabled: state.suggestionsEnabled,
        defaultQuantity: state.defaultQuantity,
      }),
    }
  )
);

export default useSearchStore;

// Re-export initial states for testing or reset purposes
export {
  initialFilterState,
  initialSearchState,
  initialRecentSearchesState,
  initialTyreState,
  initialQuantityState,
};
